import React from 'react';
import { FormContainer } from '../molecules/FormContainer';

interface AuthFormSideProps {
  /**
   * Form content to render
   */
  children: React.ReactNode;
  /**
   * Maximum width of the form container
   * @default 500
   */
  maxWidth?: number;
}

/**
 * Organism: Right side form area
 * Default canvas background with centered form container
 */
export const AuthFormSide: React.FC<AuthFormSideProps> = ({
  children,
  maxWidth = 500,
}) => {
  return (
    <div className="flex w-full items-center justify-center bg-surface-canvas">
      <FormContainer maxWidth={maxWidth}>{children}</FormContainer>
    </div>
  );
};
